import { useContext } from "react";
import { ConfigContext } from "@pd/mantis/contexts/ConfigContext";

// ==============================|| CONFIG - HOOKS ||============================== //

const useConfig = () => useContext(ConfigContext);

export default useConfig;
